import { FC, ReactNode, useContext } from "react";
import { Box, Grid, useTheme } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "./styles.css";
import { SidebarContext } from "../../contexts/SidebarContext";
import ZsBreadcrumbs from "../../shared/components/breadcrumbs";

interface SidebarLayoutProps {
  children?: ReactNode;
}
const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme();
  const { sidebarToggle } = useContext(SidebarContext);
  const location = useLocation();

  function createData(
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number
  ) {
    return { name, calories, fat, carbs, protein };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const rows = [
    createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
    createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
    createData("Eclair", 262, 16.0, 24, 6.0),
    createData("Cupcake", 305, 3.7, 67, 4.3),
    createData("Gingerbread", 356, 16.0, 49, 3.9),
  ];

  return (
    <>
      <Box>
        <Sidebar />
        <Box display="block" className="headerBox">
          <Box
            sx={{
              [theme.breakpoints.up("lg")]: {
                ml: sidebarToggle ? `${theme.sidebar.width}` : "70px",
              },
            }}
          >
            <Header />
          </Box>
        </Box>
        <Box
          sx={{
            [theme.breakpoints.up("lg")]: {
              ml: sidebarToggle ? `${theme.sidebar.width}` : "70px",
            },
          }}
        >
          {location.pathname !== "/dashboard" &&
            location.pathname !== "/dashboard/live-dashboard" && (
              <Grid container className={`subContainer`}>
                <ZsBreadcrumbs />
              </Grid>
            )}
          <Box display="block">
            <Outlet />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SidebarLayout;
